var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.5c0 3.6-3 6.5-6.5 6.5-2.2 0-4.1-1.2-5.3-3H9.3l-1-1L7 15l-1.4-1.1L4.2 15 0 11.6 3.3 8h8.8c1.1-1.7 3.1-3 5.3-3C21 5 24 7.9 24 11.5zM13.3 13c1 1.7 2.3 3 4.2 3 2.4 0 4.5-2 4.5-4.5S20 7 17.5 7c-2.1 0-3.3 1.4-4.2 3H4.2l-1.3 1.4 1.3 1.1 1.4-1.1L7 12.5l1.4-1.1 1.7 1.7c0-.1 3.2-.1 3.2-.1zM19 9.9c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
}

export default SvgIconKey;